// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// This script is provided as-is from SFPA team

export const completeGtmInitialization = (
  gtmParams: string,
  gtmContainerId: string,
) => {
  // [Start] Initialize Datalayer
  try {
    window.chewy.initializeDataLayer(true);
    window.chewy.initializeGTM();
  } catch (error) {
    console.log('Error caught in gtm', error);
    throw error;
  }
  // [End] Initialize Datalayer
  // [Start] Google Tag Manager
  try {
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src =
        'https://www.googletagmanager.com/gtm.js?id=' + i + dl + gtmParams;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', gtmContainerId);
  } catch (error) {
    console.log('Error caught in gtm tag', error);
    throw error;
  }
  // [End] Google Tag Manager
};
